import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

const Footer = () => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.SETTINGS, { timeout: 5000 });
      if (response.data.success) {
        setSettings(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  return (
    <footer className="bg-dark text-white pt-5 pb-4">
      <div className="container">
        <div className="row">
          {/* About SIKOM */}
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold mb-4">SIKOM</h5>
            <p className="text-light mb-3">
              SIKOM Peace Network for Development is a Non-governmental Organization (NGO) 
              in West Pokot County whose mission is to integrate indigenous knowledge and 
              innovative solutions to achieving sustainable development in East Africa.
            </p>
            <div className="social-links d-flex gap-3">
              {settings.facebook_url && (
                <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" className="text-white">
                  <i className="bi bi-facebook fs-5"></i>
                </a>
              )}
              {settings.twitter_url && (
                <a href={settings.twitter_url} target="_blank" rel="noopener noreferrer" className="text-white">
                  <i className="bi bi-twitter fs-5"></i>
                </a>
              )}
              {settings.linkedin_url && (
                <a href={settings.linkedin_url} target="_blank" rel="noopener noreferrer" className="text-white">
                  <i className="bi bi-linkedin fs-5"></i>
                </a>
              )}
              {settings.instagram_url && (
                <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" className="text-white">
                  <i className="bi bi-instagram fs-5"></i>
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-md-2 mb-4">
            <h5 className="fw-bold mb-4">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/about" className="text-light text-decoration-none">Who we are</Link>
              </li>
              <li className="mb-2">
                <Link to="/what-we-do" className="text-light text-decoration-none">What we do</Link>
              </li>
              <li className="mb-2">
                <Link to="/projects" className="text-light text-decoration-none">Our Projects</Link>
              </li>
              <li className="mb-2">
                <Link to="/opportunities" className="text-light text-decoration-none">Opportunities</Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-light text-decoration-none">Partner with us</Link>
              </li>
              <li>
                <Link to="/donate" className="text-light text-decoration-none">Donate</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold mb-4">Contact Us</h5>
            <ul className="list-unstyled text-light">
              <li className="mb-3">
                <i className="bi bi-geo-alt me-2"></i>
                {settings.contact_location || 'Lytei Estate, Block 2, off Makutano- Lytei Road'}
              </li>
              <li className="mb-3">
                <i className="bi bi-envelope me-2"></i>
                {settings.contact_email || 'info@sikompeacenet.org'}
              </li>
              <li className="mb-3">
                <i className="bi bi-telephone me-2"></i>
                {settings.contact_phone || '+254711538258'}
              </li>
              <li>
                <i className="bi bi-clock me-2"></i>
                Mon - Fri: 8:00 AM - 5:00 PM
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="col-md-3 mb-4">
            <h5 className="fw-bold mb-4">Stay Updated</h5>
            <p className="text-light mb-3">
              Subscribe to our newsletter for latest updates.
            </p>
            <form className="newsletter-form">
              <div className="input-group mb-3">
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Your email" 
                  aria-label="Your email"
                />
                <button className="btn btn-primary" type="submit">
                  <i className="bi bi-send"></i>
                </button>
              </div>
            </form>
          </div>
        </div>

        <hr className="bg-light my-4" />

        <div className="row">
          <div className="col-md-6">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} SIKOM Peace Network for Development. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-md-end">
            <p className="mb-0">
              Designed by Boldcomp Solutions with <i className="bi bi-heart-fill text-danger"></i> for peace and development
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;